import QueryString from 'qs';

import { activityRelationApi } from '../activity/relation';
import { LoginResponse } from '../auth/types';
import { jsonApi } from '../client';
import { generateResourceScoutApi } from '../scout/api';
import type { PaginationQuery, PaginationResource } from '../types/pagination';
import { generateResourceViewApi } from '../view/api';
import type { StoreUserRequest, UpdateUserRequest, User } from './types';

const user = jsonApi('user');

const index = (query?: PaginationQuery): Promise<PaginationResource<User>> => {
  return user.get(undefined, {
    searchParams: QueryString.stringify(query),
  });
};

const show = (id: string | number): Promise<User> => {
  return user.get(id.toString());
};

const store = (data: StoreUserRequest): Promise<User> => {
  return user.post(undefined, data);
};

const update =
  (id: string | number) =>
  (data: UpdateUserRequest): Promise<unknown> => {
    return user.put(id.toString(), data);
  };

const impersonate = (id: string | number): Promise<LoginResponse> => {
  return user.post(`${id.toString()}/impersonate`);
};

const stopImpersonate = (): Promise<unknown> => {
  return user.post('stop-impersonate');
};

const destroy = (id: string | number): Promise<unknown> => {
  return user.delete(id.toString());
};

const favorite = (id: string | number): Promise<unknown> => {
  return user.post(`${id}/favorite`);
};

export const userApi = {
  name: 'user',
  index,
  show,
  store,
  update,
  impersonate,
  stopImpersonate,
  destroy,
  favorite,
  relation: {
    activity: activityRelationApi('user'),
  },
  view: generateResourceViewApi('user'),
  scout: generateResourceScoutApi<User>('user', (item) => ({
    label: [item.full_name, item.organisation?.name].filter(Boolean).join(' - '),
    value: item.id,
  })),
};
